<ng-container>
	<base-display #display [alignment]="'left'" [smallLetters]="'CALL'" [bigLetters]="b()" [unit]="''"></base-display>
</ng-container>
